//src/Components/EmojiPicker/EmojisList.tsx
import { EmojiData } from '.';
import Emoji from './Emoji';

export default function EmojisList({
  emojis,
  groupName,
}: {
  groupName: string;
  emojis: EmojiData[];
}) {
  return (
    <div>
      <div className="capitalize text-gray-dark font-bold text-sm py-2 ">
        {groupName}
      </div>
      <div className="flex flex-wrap">
        {emojis.map((emoji) => (
          <Emoji emoji={emoji} key={emoji.id} />
        ))}
      </div>
    </div>
  );
}
